import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ShellApi } from 'vrlcm-gui-api';
import { ShellApp } from 'vrlcm-gui-types';
import { requestAppsFailed, requestAppsSuccess } from '../actions/Dashboard';
import * as Constants from '../constants/action-constants';

function* getApps() {
  try {
    const apps: ShellApp[] = yield call(ShellApi.getApps);
    yield put(requestAppsSuccess(apps));
  } catch (error) {
    yield put(requestAppsFailed());
  }
}

function* watchForGetApps() {
  yield takeLatest(Constants.REQUEST_APPS, getApps);
}

export default function* dashboardSaga() {
  yield all([watchForGetApps()]);
}
